import { sendersInfoParams } from '../dataBox'


export function useTransferActions() {
  return {
    refetch: () => sendersInfoParams.updateData(() => ({})),
  }
}
